import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    // MESSAGES
    addMessage(state, payload) {
        const message = payload.message;
        const append = payload.append || false;

        // Find conversation
        const tmpConversation = state.conversations.find(value => value.id == message.conversation_id);

        if (empty(tmpConversation)) {
            return;
        }

        if (message.id) {
            // Loop messages to find already existing
            let tmpMessage = tmpConversation.messages.find(value => value.id == message.id);

            // Set message if found
            if (!empty(tmpMessage)) {
                tmpMessage = message;
                return;
            }
        }

        // Add message to conversation
        if (append) {
            tmpConversation.messages.push(message);
        } else {
            tmpConversation.messages.unshift(message);
        }
    },
    markAllMessagesAsRead(state, conversationId) {
        // Find conversation
        const tmpConversation = state.conversations.find(value => value.id == conversationId);

        if (empty(tmpConversation)) {
            return;
        }

        // Loop messages
        for (let i = 0; i < tmpConversation.messages.length; i++) {
            // Mark message as read
            tmpConversation.messages[i].read = true;
        }
    },

    // CONVERSATIONS
    resetFetch(state, clearConversations = true) {
        if (clearConversations) {
            state.conversations = [];
        }

        state.selectedConversationId = null;
        state.conversationsPage = 1;
        state.conversationsFetchId += 1;
    },
    incrementConversationsPage(state) {
        state.conversationsPage += 1;
    },
    setConversations(state, conversations) {
        state.conversations = conversations;
    },
    addConversations(state, conversations) {
        for (const conversation of conversations) {
            // Find matching conversation
            const tmpConversation = state.conversations.find(value => value.id == conversation.id);

            // Add if not found
            if (empty(tmpConversation)) {
                state.conversations.push(conversation);
            }
        }
    },
    setSelectedConversationId(state, conversationId) {
        state.selectedConversationId = conversationId;
    },
    removeSelectedConversation(state) {
        state.selectedConversationId = null;
    },
    changeSelectedConversationActivation(state, activate) {
        const tmpSelectedConversation = state.conversations.find(value => value.id == state.selectedConversationId);

        tmpSelectedConversation.active = activate;
    },
    changeSelectedConversationContactPhone(state, conversation) {
        const tmpSelectedConversation = state.conversations.find(value => value.id == state.selectedConversationId);

        tmpSelectedConversation.contact_phone = conversation.contact_phone;
        tmpSelectedConversation.contact_phone_id = conversation.contact_phone.id;
        tmpSelectedConversation.audits = conversation.audits;
    },
    changeSelectedConversationProviderPhone(state, conversation) {
        const tmpSelectedConversation = state.conversations.find(value => value.id == state.selectedConversationId);

        tmpSelectedConversation.provider_phone = conversation.provider_phone;
    },
    setConversationsTotal(state, conversationsTotal) {
        state.conversationsTotal = conversationsTotal;
    },
    setShowActiveConversation(state, showActive) {
        state.showActiveConversation = showActive;
    },
    setIntelligentFilterEnabled(state, isEnabled) {
        state.intelligentFilterEnabled = isEnabled;
    },

    // MESSAGE TEMPLATES
    setSelectedTemplate(state, template) {
        state.selectedTemplate = template;
    },

    // TEMPLATE CATEGORIES
    setTemplateCategories(state, templateCategories) {
        state.templateCategories = templateCategories;
    },
    setSelectedTemplateCategory(state, category) {
        state.selectedTemplateCategory = category;
    },

    // SENDING
    setSending(state, sending) {
        state.sending = sending;
    },

    // RELATED IDS
    setContactRelatedId(state, contactRelatedId) {
        state.contactRelatedId = contactRelatedId;
    },
    setUserRelatedId(state, userRelatedId) {
        state.userRelatedId = userRelatedId;
    },

    // CONTACT
    setSelectedContactId(state, selectedContactId) {
        state.selectedContactId = selectedContactId;
    },
    updateConversationContact(state, contact) {
        if (!contact.id) {
            return;
        }

        state.conversations
            .filter(conversation => conversation.contact_phone.contact.id == contact.id)
            .forEach(conversation => Object.assign(conversation.contact_phone.contact, contact));
    },
    updateConversationContactPhone(state, contactPhone) {
        state.conversations
            .filter(conversation => conversation.contact_phone.id == contactPhone.id)
            .forEach(conversation => Object.assign(conversation.contact_phone, contactPhone));
    },

    setSelectedUserId(state, selectedUserId) {
        state.selectedUserId = selectedUserId;
    },
};
